export const SET_SIDE_MENU_OPEN = "SET_SIDE_MENU_OPEN";
export const CONTENT_LOADING = "CONTENT_LOADING";
export const SET_SIDE = "SET_SIDE";
export const SET_SHOW_MOBILE_SUMMARY = "SET_SHOW_MOBILE_SUMMARY";
